import { collection, getDocs, doc, setDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

const colRef = collection(db, 'catalogue');

// 1. Fetch all docs once for the Miller tree
export async function fetchCatalogue() {
  const snap = await getDocs(colRef);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}


/* Tidies the typed category names before they are saved (2026-09-28). The
   configurator's slug turns each run of spaces into one hyphen and uses "--"
   to separate levels, so a double space ("Chromebook  314") or a "--" inside
   a name breaks basket rehydration. Trims, collapses runs of spaces, and
   collapses runs of hyphens to one. Single hyphens ("E-ink") are kept. */
const tidyName = v => v.replace(/\s+/g, ' ').replace(/-{2,}/g, '-').trim();

export function tidyNames(device) {
  const out = { ...device };
  for (let i = 1; i <= 10; i += 1) {
    const k = `cat_${i}`;
    if (typeof out[k] === 'string') out[k] = tidyName(out[k]);
  }
  return out;
}

/* create / overwrite device */
export async function saveDevice(untidyDevice) {
  const device = tidyNames(untidyDevice);
  const snap = await getDocs(colRef);
    
/* helper: normalise for comparison */
const norm = v => (v ?? '').toString().trim().toLowerCase();

/* helper: build a readable path string */
const pathStr = obj =>
  ['cat_1','cat_2','cat_3','cat_4','cat_5',
   'cat_6','cat_7','cat_8','cat_9','cat_10']
    .map(k => obj[k]).filter(Boolean).join(' / ');

let clash = null;

snap.docs.forEach(d => {
  /* Ignore the doc we are *currently editing* so we don’t
     flag it as a duplicate of itself. */
  if (device.UID && d.id === device.UID) return;

  const data = d.data();
  const samePath = ['cat_1','cat_2','cat_3','cat_4','cat_5',
                    'cat_6','cat_7','cat_8','cat_9','cat_10']
      .every(k => norm(data[k]) === norm(device[k]));

  if (!samePath) return;                         // no collision

  const exactMatch = ['cat_1','cat_2','cat_3','cat_4','cat_5',
                      'cat_6','cat_7','cat_8','cat_9','cat_10']
      .every(k => (data[k] ?? '') === (device[k] ?? ''));

  clash = {
    exact   : exactMatch,
    current : pathStr(data),
    entered : pathStr(device),
  };
});

if (clash) {
  if (clash.exact) {
    throw new Error('Duplicate category path – not saved');
  } else {
    throw new Error(
      `Category path already exists with different capitalisation:\n` +
      `  existing → ${clash.current}\n` +
      `  entered  → ${clash.entered}\n\n` +
      `Please adjust the casing to match the existing branch.`
    );
  }
}

  // const id     = device.UID || undefined;          // undefined → new auto-id
  // const docRef = id ? doc(colRef, id) : doc(colRef); // create vs add
  // await setDoc(docRef, { ...device, UID: docRef.id }, { merge: false });
  // return docRef.id;


  // If the device is new (no UID), generate a standard UUID for its ID.
  // Otherwise, use its existing UID.
  // const docId = device.UID || crypto.randomUUID();
  // const docRef = doc(colRef, docId);
  // // Ensure the UID field in the data explicitly matches the document ID
  // await setDoc(docRef, { ...device, UID: docId }, { merge: false });

  // --- NEW: Slug Generation Logic ---
  const pathArray = ['cat_1','cat_2','cat_3','cat_4','cat_5',
                     'cat_6','cat_7','cat_8','cat_9','cat_10']
    .map(k => device[k])
    .filter(Boolean);

  const slug = pathArray
    .map(seg => seg.toString().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''))
    .join('--');

  const docId = device.UID || crypto.randomUUID();
  const finalDevice = { ...device, UID: docId, react_cat_routing_slug: slug };
  
  const docRef = doc(colRef, docId);
  await setDoc(docRef, finalDevice, { merge: false });

  return docId;
}